import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import {
  IGetRadniNalogTableQuery,
  StatusRadnogNaloga,
  StatusRadnogNalogaDto,
  VrstaRadnogNaloga,
  VrstaRadnogNalogaDto,
} from '@kodit/core/data-api';
import { BaseStrankaFormService } from '@kodit/core/form-definitions';
import { AdvancedFilter } from '@kodit/core/shared-ui';
import { FormGroupTypeSafe } from 'angular-typesafe-reactive-forms-helper';
import { RacunFilterService } from 'libs/core/shared-subforms/src/lib/racun/racun-filter/racun-filter.service';

@Component({
  selector: 'kodit-radni-nalog-filter',
  templateUrl: './radni-nalog-filter.component.html',
})
export class RadniNalogFilterComponent
  implements OnInit, OnDestroy, AdvancedFilter<IGetRadniNalogTableQuery>
{
  filterData: IGetRadniNalogTableQuery;
  form: FormGroupTypeSafe<IGetRadniNalogTableQuery>;
  filterForm: FormGroup;

  vrsteOptions = [
    { label: 'Proizvodnja po narudžbini', value: VrstaRadnogNaloga.PROIZVODNJA_PO_NARUDZBINI },
    { label: 'Proizvodnja za lager', value: VrstaRadnogNaloga.PROIZVODNJA_ZA_LAGER },
    { label: 'Uslužna delatnost', value: VrstaRadnogNaloga.USLUZNA_DELATNOST },
    { label: 'Građevina', value: VrstaRadnogNaloga.GRAĐEVINA },
    { label: 'Evidencija vremena i materijala', value: VrstaRadnogNaloga.EVIDENCIJA_VREMENA_I_MATERIJALA },
    { label: 'Zbirni dnevni radni nalog', value: VrstaRadnogNaloga.ZBIRNI_DNEVNI },
  ];

  statusiOptions = [
    { label: 'Nacrt', value: StatusRadnogNaloga.NACRT },
    { label: 'Započet', value: StatusRadnogNaloga.ZAPOCET },
    { label: 'Završen', value: StatusRadnogNaloga.ZAVRSEN },
    { label: 'Poništen', value: StatusRadnogNaloga.OTKAZAN },
  ];

  constructor(
    private _strankaFormService: BaseStrankaFormService,
    private _racunFilterService: RacunFilterService
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      broj: new FormControl(this.filterData?.broj ?? null),
      stranke: this._strankaFormService.GetStrankeFormArray(
        (this.filterData?.stranke as any[]) ?? []
      ),
      statusi: new FormControl(
        (this.filterData?.statusi ?? []).map((x) => x.status)
      ),
      vrste: new FormControl(
        (this.filterData?.vrste ?? []).map((x) => x.vrsta)
      ),
    });
    this.form = this.filterForm as unknown as FormGroupTypeSafe<IGetRadniNalogTableQuery>;
  }

  get strankeFormArray(): FormArray {
    return this.filterForm.controls.stranke as FormArray;
  }

  onFilterSubmit() {
    this._racunFilterService.setAdvanceFilterSubmitted = {
      filterData: this._kreirajFilter() as any,
      shouldApplyFilter: true,
    };
  }

  onFilterHide(shouldReset: boolean) {
    this._racunFilterService.setAdvanceFilterSubmitted = {
      filterData: (shouldReset ? {} : this._kreirajFilter()) as any,
      shouldApplyFilter: shouldReset,
    };
  }

  private _kreirajFilter(): IGetRadniNalogTableQuery {
    const value = this.filterForm.value;
    return {
      broj: value.broj,
      stranke: value.stranke ?? [],
      statusi: (value.statusi ?? []).map(
        (status: StatusRadnogNaloga) => new StatusRadnogNalogaDto({ status })
      ),
      vrste: (value.vrste ?? []).map(
        (vrsta: VrstaRadnogNaloga) => new VrstaRadnogNalogaDto({ vrsta })
      ),
    };
  }

  ngOnDestroy(): void {}
}
